var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plabel",class:[{ flex: _vm.flex }]},[_c('span',{staticClass:"plabel-text"},[(_vm.text)?_c('i',{staticClass:"el-icon-s-unfold"}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_c('span',{staticStyle:{"margin-left":"auto"},on:{"click":_vm.packUpClick}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }